/** PII field names. Any property key containing one of these strings is redacted. */
export const piiKeys = [
  'email',
  'phone',
  'address',
  'password',
  'token',
  'authorization',
  'cookie',
  'body',
] as const;

/** Recursively redacts PII keys from an arbitrary object. */
export function scrubObject(value: unknown): unknown {
  if (value === null || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(scrubObject);

  const output: Record<string, unknown> = {};
  for (const [key, nestedValue] of Object.entries(value as Record<string, unknown>)) {
    const lowerKey = key.toLowerCase();
    if (piiKeys.some((piiKey) => lowerKey.includes(piiKey))) {
      output[key] = '[REDACTED]';
      continue;
    }
    output[key] =
      typeof nestedValue === 'object' && nestedValue !== null
        ? scrubObject(nestedValue)
        : nestedValue;
  }
  return output;
}
